import { useTranslation } from 'react-i18next';
const HeroSection = () => {

    const { t } = useTranslation();

    return (
        <div className="cc-header-img">
            <div className="c-header-img">
                <img className="o-loader" hidden="" />
                <img alt="" className="" src="https://pro-static.h10hotels.com/gallery/Cabecera_Interior_OCS.jpg" />
                <h1 >Ofertas destacadas</h1>
            </div>
        </div>
    );
}

export default HeroSection
